import { useContext } from 'react';
import { DialogContext } from './DialogContext';

export default function useDialog() {
  const dialog = useContext(DialogContext);

  if (!dialog) {
    throw new Error("useDialog: no DialogProvider mounted. Mount <SharedProviders> (from 'shared').");
  }

  return dialog;
}
